import React, { useState } from "react";
import "./App.css";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Navigation from "./components/Navigation";
import ParticleBackground from "./components/ParticleBackground";
// import MusicPlayer from "./components/MusicPlayer";
import WelcomeOverlay from "./components/WelcomeOverlay";
import Footer from "./components/Footer";

function App() {
  const [showWelcome, setShowWelcome] = useState(true);
  // const [startMusic, setStartMusic] = useState(false);
  const [hasEntered, setHasEntered] = useState(false);

  const handleEnter = () => {
    setShowWelcome(false);
    // setStartMusic(true);
    setHasEntered(true);
  };

  return (
    <div className="App">
      <WelcomeOverlay isVisible={showWelcome} onEnter={handleEnter} />
      <ParticleBackground>
        <Navigation />
        <Hero hasEntered={hasEntered} />
        <About />
        <Skills />
        <Projects />
        <Contact />
        <Footer />
      </ParticleBackground>
      {/* <MusicPlayer shouldPlay={startMusic} /> */}
    </div>
  );
}

export default App;
